import React, { Component } from 'react';
import { toast } from 'react-toastify';
import ReactCustomFlagSelect from '../../ReactCustomFlagSelect';
import staticData from '../../static';
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import CarOptionList from './CarOptionList';
import { carMakeList, carColorList } from '../../static';
import {
  nonSpecialCharacterForValue,
  isValidEmail,
  PICKER_LANG,
  getMonthPickerLimits,
  formatMonthYear
} from '../helpers/monthlyRegistrationHelpers';
import '../../styles/monthly-registration/monthlyRegistration.css';

export default class AccountInfoForm extends Component {
  constructor(props) {
    super(props);
    this.pickMulti = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (this.pickMulti.current && 
        !e.target.closest('.rmp-popup') &&
        !e.target.closest('.customer-info-form__date-trigger') &&
        !e.target.closest('.customer-info-form__date-picker')) {
      try {
        this.pickMulti.current.dismiss();
      } catch (err) {}
    }
  };

  handleChange = (e) => this.props.onAccountChange?.(e);
  handleAreaCode = (areaCode) => this.props.onAccountAreaCode?.(areaCode);

  handleMemberChange = (index, field, value) => {
    this.props.onUpdateMember?.(index, field, value);
    if (field === 'vehicle_no') setTimeout(() => this.validateForm(false), 100);
  };

  handleMemberAreaCode = (index, areaCode) => this.props.onUpdateMemberAreaCode?.(index, areaCode);

  handleDateChange = (year, month) => {
    this.props.onAccountDateChange?.({ year, month });
    this.pickMulti.current?.dismiss();
  };

  addMember = () => this.props.onAddMember?.();
  removeMember = (index) => this.props.onRemoveMember?.(index);
  addMemberAlternateVehicle = (memberIndex) => this.props.onAddAlternateVehicleToMember?.(memberIndex);
  removeMemberAlternateVehicle = (memberIndex, altIndex) => this.props.onRemoveAlternateVehicleFromMember?.(memberIndex, altIndex);
  updateMemberAlternateVehicle = (memberIndex, altIndex, field, value) => this.props.onUpdateAlternateVehicleInMember?.(memberIndex, altIndex, field, value);

  openCarMakeModal = (memberIndex, altIndex = null) => {
    altIndex !== null 
      ? this.props.onOpenAccountAlternateCarMakeModal?.(memberIndex, altIndex)
      : this.props.onOpenAccountCarMakeModal?.(memberIndex);
  };

  openCarColorModal = (memberIndex, altIndex = null) => {
    altIndex !== null
      ? this.props.onOpenAccountAlternateCarColorModal?.(memberIndex, altIndex)
      : this.props.onOpenAccountCarColorModal?.(memberIndex);
  };

  closeModal = () => this.props.onCloseAccountModal?.();
  handleCarMakeChange = (value) => this.props.onAccountCarMakeChange?.(value);
  handleCarColorChange = (value) => this.props.onAccountCarColorChange?.(value);

  validateForm = (showErrors = false) => {
    const errors = {};
    const fields = this.props.fields || {};
    const members = this.props.members || [];
    const validity = this.props.validity;
    let isValid = true;

    if (showErrors) {
      if (!fields.company_name) { errors.company_name = 'Company name is required'; isValid = false; }
      if (!fields.first_name) { errors.first_name = 'First name is required'; isValid = false; }
      if (!fields.last_name) { errors.last_name = 'Last name is required'; isValid = false; }
      if (!fields.phone1) { errors.phone1 = 'Mobile number is required'; isValid = false; }
      if (!fields.admin_email) { errors.admin_email = 'Admin email is required'; isValid = false; }
      if (!validity?.year || !validity?.month) { errors.startDate = 'Start date is required'; isValid = false; }

      if (fields.admin_email && !isValidEmail(fields.admin_email)) {
        toast.error('Please enter a valid admin email address');
        isValid = false;
      }

      members.forEach((member, index) => {
        if (!member?.first_name) { errors[`member_${index}_first_name`] = 'First name is required'; isValid = false; }
        if (!member?.last_name) { errors[`member_${index}_last_name`] = 'Last name is required'; isValid = false; }
        if (!member?.phone1) { errors[`member_${index}_phone1`] = 'Mobile number is required'; isValid = false; }
        if (!member?.email) { errors[`member_${index}_email`] = 'Email is required'; isValid = false; }
        if (!member?.vehicle_no) { errors[`member_${index}_vehicle_no`] = 'License plate is required'; isValid = false; }
        if (!member?.vehicle_make) { errors[`member_${index}_vehicle_make`] = 'Car make is required'; isValid = false; }
        if (!member?.vehicle_model) { errors[`member_${index}_vehicle_model`] = 'Model is required'; isValid = false; }
        if (!member?.vehicle_color) { errors[`member_${index}_vehicle_color`] = 'Color is required'; isValid = false; }
        
        if (member?.email && !isValidEmail(member.email)) {
          toast.error(`Please enter a valid email address for member ${index + 1}`);
          isValid = false;
        }
      });
    }

    members.forEach((member, index) => {
      if (member?.vehicle_no && nonSpecialCharacterForValue(member.vehicle_no)) {
        errors[`member_${index}_vehicle_no`] = 'Special characters are not allowed in license plate';
      }
      member?.alternate_vehicles?.forEach((alt, altIndex) => {
        if (showErrors && !alt?.vehicle_no) {
          errors[`member_${index}_alt_${altIndex}_vehicle_no`] = 'License plate is required';
          isValid = false;
        } else if (alt?.vehicle_no && nonSpecialCharacterForValue(alt.vehicle_no)) {
          errors[`member_${index}_alt_${altIndex}_vehicle_no`] = 'Special characters are not allowed in license plate';
          isValid = false;
        }
      });
    });

    this.props.onSetAccountErrors?.(errors);
    return isValid && Object.keys(errors).length === 0;
  };

  isFormValid = () => {
    const fields = this.props.fields || {};
    const members = this.props.members || [];
    const validity = this.props.validity;
    
    if (!fields.company_name || !fields.first_name || !fields.last_name || !fields.phone1 || !fields.admin_email) return false;
    if (!validity?.year || !validity?.month) return false;
    if (!members?.length) return false;
    
    return members.every(member => {
      if (!member) return false;
      const hasBasics = member.first_name && member.last_name && member.phone1 && member.email;
      const hasVehicle = member.vehicle_no && !nonSpecialCharacterForValue(member.vehicle_no) && member.vehicle_make && member.vehicle_model && member.vehicle_color;
      const hasValidAlts = (member.alternate_vehicles || []).every(alt => {
        if (!alt) return true;
        // For accounts, vehicle_no (plate) is mandatory for alternate vehicles
        return alt.vehicle_no && !nonSpecialCharacterForValue(alt.vehicle_no);
      });
      return hasBasics && hasVehicle && hasValidAlts;
    });
  };

  handleContinue = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.submittingForm) return false;
    if (!this.validateForm(true)) return false;
    if (this.props.onContinueToPayment) {
      this.props.onContinueToPayment();
    } else {
      toast.error('Unable to submit form');
    }
    return false;
  };

  renderRemoveIcon = (size = 12) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="customer-info-form__remove-icon">
      <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
    </svg>
  );

  renderAddIcon = (size = 16) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="customer-info-form__add-icon">
      <path d="M5 12h14"></path><path d="M12 5v14"></path>
    </svg>
  );

  renderCalendarIcon = () => (
    <svg className="customer-info-form__calendar-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  );

  renderCarSelectField = (label, value, onClick, error, required = false) => (
    <div className="customer-info-form__field">
      <label className="customer-info-form__label">{label}{required && <span className="required">*</span>}</label>
      <div className="customer-info-form__input-with-icon" onClick={onClick} style={{ cursor: 'pointer' }}>
        <input type="text" value={value} onClick={(e) => { e.stopPropagation(); onClick(); }} placeholder={`Select ${label.toLowerCase()}`} className={`customer-info-form__input ${error ? 'error' : ''}`} style={{ textTransform: 'capitalize', cursor: 'pointer' }} readOnly />
        <i className="fa fa-list customer-info-form__icon" onClick={(e) => { e.stopPropagation(); onClick(); }} aria-hidden="true"></i>
      </div>
      {error && <span className="customer-info-form__error">{error}</span>}
    </div>
  );

  renderMemberAlternateVehicle = (altVehicle, memberIndex, altIndex, errors) => (
    <div key={altIndex} className="customer-info-form__alternate-vehicle">
      <div className="customer-info-form__alternate-vehicle-header">
        <label className="customer-info-form__label">Alternate Vehicle {altIndex + 1}</label>
        <button type="button" onClick={() => this.removeMemberAlternateVehicle(memberIndex, altIndex)} className="customer-info-form__remove-btn">{this.renderRemoveIcon()}</button>
      </div>
      <div className="customer-info-form__field">
        <label className="customer-info-form__label">Plate <span className="required">*</span></label>
        <input
          type="text"
          value={altVehicle.vehicle_no}
          onChange={(e) => { this.updateMemberAlternateVehicle(memberIndex, altIndex, 'vehicle_no', e.target.value); setTimeout(() => this.validateForm(false), 100); }}
          placeholder="License plate"
          className={`customer-info-form__input customer-info-form__input--uppercase ${errors[`member_${memberIndex}_alt_${altIndex}_vehicle_no`] ? 'error' : ''}`}
          style={{ textTransform: 'uppercase' }}
          onKeyPress={(e) => nonSpecialCharacterForValue(e.key) && e.preventDefault()}
        />
        {errors[`member_${memberIndex}_alt_${altIndex}_vehicle_no`] && <span className="customer-info-form__error">{errors[`member_${memberIndex}_alt_${altIndex}_vehicle_no`]}</span>}
      </div>
      <div className="customer-info-form__row">
        {this.renderCarSelectField('Make', altVehicle.vehicle_make, () => this.openCarMakeModal(memberIndex, altIndex))}
        {this.renderCarSelectField('Color', altVehicle.vehicle_color, () => this.openCarColorModal(memberIndex, altIndex))}
      </div>
    </div>
  );

  renderMemberCard = (member, memberIndex, errors, minMembers, membersLength) => (
    <div key={memberIndex} className="customer-info-form__member-card">
      <div className="customer-info-form__member-header">
        <label className="customer-info-form__label customer-info-form__label--member">Member {memberIndex + 1}</label>
        {membersLength > minMembers && (
          <button type="button" onClick={() => this.removeMember(memberIndex)} className="customer-info-form__remove-btn">{this.renderRemoveIcon()}</button>
        )}
      </div>

      <div className="customer-info-form__row">
        <div className="customer-info-form__field">
          <label className="customer-info-form__label">First Name <span className="required">*</span></label>
          <input type="text" value={member.first_name} onChange={(e) => this.handleMemberChange(memberIndex, 'first_name', e.target.value)} placeholder="Enter first name" className={`customer-info-form__input ${errors[`member_${memberIndex}_first_name`] ? 'error' : ''}`} />
          {errors[`member_${memberIndex}_first_name`] && <span className="customer-info-form__error">{errors[`member_${memberIndex}_first_name`]}</span>}
        </div>
        <div className="customer-info-form__field">
          <label className="customer-info-form__label">Last Name <span className="required">*</span></label>
          <input type="text" value={member.last_name} onChange={(e) => this.handleMemberChange(memberIndex, 'last_name', e.target.value)} placeholder="Enter last name" className={`customer-info-form__input ${errors[`member_${memberIndex}_last_name`] ? 'error' : ''}`} />
          {errors[`member_${memberIndex}_last_name`] && <span className="customer-info-form__error">{errors[`member_${memberIndex}_last_name`]}</span>}
        </div>
      </div>

      <div className="customer-info-form__field">
        <label className="customer-info-form__label">Mobile <span className="required">*</span></label>
        <div className="customer-info-form__phone-group">
          <div className="customer-info-form__country-code">
            <ReactCustomFlagSelect showSearch={false} showArrow={true} animate={true} value={member.areaCode} customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }} optionList={staticData.countryCode} onChange={(areaCode) => this.handleMemberAreaCode(memberIndex, areaCode)} />
          </div>
          <input type="tel" value={member.phone1} onChange={(e) => this.handleMemberChange(memberIndex, 'phone1', e.target.value)} placeholder="Phone number" className={`customer-info-form__input customer-info-form__input--phone ${errors[`member_${memberIndex}_phone1`] ? 'error' : ''}`} />
        </div>
        {errors[`member_${memberIndex}_phone1`] && <span className="customer-info-form__error">{errors[`member_${memberIndex}_phone1`]}</span>}
      </div>

      <div className="customer-info-form__field">
        <label className="customer-info-form__label">Email <span className="required">*</span></label>
        <input type="text" value={member.email ?? ''} onChange={(e) => this.handleMemberChange(memberIndex, 'email', e.target.value)} placeholder="Enter email" className={`customer-info-form__input ${errors[`member_${memberIndex}_email`] && !member.email ? 'error' : ''}`} />
        {errors[`member_${memberIndex}_email`] && !member.email && <span className="customer-info-form__error">{errors[`member_${memberIndex}_email`]}</span>}
      </div>

      <div className="customer-info-form__field">
        <label className="customer-info-form__label">License Plate <span className="required">*</span></label>
        <input type="text" value={member.vehicle_no} onChange={(e) => this.handleMemberChange(memberIndex, 'vehicle_no', e.target.value)} placeholder="Enter license plate" className={`customer-info-form__input customer-info-form__input--uppercase ${errors[`member_${memberIndex}_vehicle_no`] ? 'error' : ''}`} style={{ textTransform: 'uppercase' }} onKeyPress={(e) => nonSpecialCharacterForValue(e.key) && e.preventDefault()} />
        {errors[`member_${memberIndex}_vehicle_no`] && <span className="customer-info-form__error">{errors[`member_${memberIndex}_vehicle_no`]}</span>}
      </div>

      <div className="customer-info-form__row customer-info-form__row--three">
        {this.renderCarSelectField('Car Make', member.vehicle_make, () => this.openCarMakeModal(memberIndex), errors[`member_${memberIndex}_vehicle_make`], true)}
        <div className="customer-info-form__field">
          <label className="customer-info-form__label">Model <span className="required">*</span></label>
          <input type="text" value={member.vehicle_model} onChange={(e) => this.handleMemberChange(memberIndex, 'vehicle_model', e.target.value)} placeholder="e.g., Camry" className={`customer-info-form__input ${errors[`member_${memberIndex}_vehicle_model`] ? 'error' : ''}`} />
          {errors[`member_${memberIndex}_vehicle_model`] && <span className="customer-info-form__error">{errors[`member_${memberIndex}_vehicle_model`]}</span>}
        </div>
        {this.renderCarSelectField('Color', member.vehicle_color, () => this.openCarColorModal(memberIndex), errors[`member_${memberIndex}_vehicle_color`], true)}
      </div>

      {member.alternate_vehicles.map((altVehicle, altIndex) => this.renderMemberAlternateVehicle(altVehicle, memberIndex, altIndex, errors))}

      <button type="button" onClick={() => this.addMemberAlternateVehicle(memberIndex)} className="customer-info-form__add-btn customer-info-form__add-btn--small">
        {this.renderAddIcon(12)}<span>Add Alternate Vehicle</span>
      </button>
    </div>
  );

  render() {
    const fields = this.props.fields || {};
    const members = this.props.members || [];
    const errors = this.props.errors || {};
    const validity = this.props.validity;
    const minMembers = this.props.minMembers || 5;
    const { showAccountCarMakeModal, showAccountCarColorModal, currentMemberIndex, currentAccountAlternateIndex, parkingId } = this.props;

    const { min: monthPickerLimitMin, max: monthPickerLimitMax } = getMonthPickerLimits(parkingId);

    return (
      <form onSubmit={this.handleContinue} className="customer-info-form" noValidate>
        <div className="customer-info-card">
          <div className="customer-info-card__header">
            <h3 className="customer-info-card__title">Company Information</h3>
          </div>
          <div className="customer-info-card__content">
            <div className="customer-info-form__field">
              <label className="customer-info-form__label">Company Name <span className="required">*</span></label>
              <input type="text" name="company_name" value={fields.company_name} onChange={this.handleChange} placeholder="Enter company name" className={`customer-info-form__input ${errors.company_name ? 'error' : ''}`} />
              {errors.company_name && <span className="customer-info-form__error">{errors.company_name}</span>}
            </div>

            <div className="customer-info-form__row">
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">First Name <span className="required">*</span></label>
                <input type="text" name="first_name" value={fields.first_name} onChange={this.handleChange} placeholder="Enter first name" className={`customer-info-form__input ${errors.first_name ? 'error' : ''}`} />
                {errors.first_name && <span className="customer-info-form__error">{errors.first_name}</span>}
              </div>
              <div className="customer-info-form__field">
                <label className="customer-info-form__label">Last Name <span className="required">*</span></label>
                <input type="text" name="last_name" value={fields.last_name} onChange={this.handleChange} placeholder="Enter last name" className={`customer-info-form__input ${errors.last_name ? 'error' : ''}`} />
                {errors.last_name && <span className="customer-info-form__error">{errors.last_name}</span>}
              </div>
            </div>

            <div className="customer-info-form__field">
              <label className="customer-info-form__label">Mobile Number <span className="required">*</span></label>
              <div className="customer-info-form__phone-group">
                <div className="customer-info-form__country-code">
                  <ReactCustomFlagSelect showSearch={false} showArrow={true} animate={true} value={fields.areaCode} customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }} optionList={staticData.countryCode} onChange={this.handleAreaCode} />
                </div>
                <input type="tel" name="phone1" value={fields.phone1} onChange={this.handleChange} placeholder="Phone number" className={`customer-info-form__input customer-info-form__input--phone ${errors.phone1 ? 'error' : ''}`} />
              </div>
              {errors.phone1 && <span className="customer-info-form__error">{errors.phone1}</span>}
            </div>

            <div className="customer-info-form__field">
              <label className="customer-info-form__label">Admin Email <span className="required">*</span></label>
              <input type="text" name="admin_email" value={fields.admin_email ?? ''} onChange={this.handleChange} placeholder="Enter admin email address" className={`customer-info-form__input ${errors.admin_email && !fields.admin_email ? 'error' : ''}`} />
              {errors.admin_email && !fields.admin_email && <span className="customer-info-form__error">{errors.admin_email}</span>}
            </div>

            <div className="customer-info-form__field">
              <label className="customer-info-form__label">Select Start Date <span className="required">*</span></label>
              <div className="customer-info-form__date-picker">
                <Picker ref={this.pickMulti} years={{ min: monthPickerLimitMin, max: monthPickerLimitMax }} value={validity} onChange={this.handleDateChange} lang={PICKER_LANG.months} theme="light">
                  <div className="customer-info-form__date-trigger" onClick={(e) => { e.stopPropagation(); this.pickMulti.current?.show(); }}>
                    {this.renderCalendarIcon()}
                    <span>{formatMonthYear(validity)}</span>
                  </div>
                </Picker>
              </div>
              {errors.startDate && <span className="customer-info-form__error">{errors.startDate}</span>}
            </div>
          </div>
        </div>

        <div className="customer-info-card">
          <div className="customer-info-card__header">
            <h3 className="customer-info-card__title">Member Details (Minimum {minMembers} members)</h3>
          </div>
          <div className="customer-info-card__content customer-info-card__content--members">
            {members.map((member, memberIndex) => this.renderMemberCard(member, memberIndex, errors, minMembers, members.length))}
            <button type="button" onClick={this.addMember} className="customer-info-form__add-btn">
              {this.renderAddIcon()}<span>Add Member</span>
            </button>
          </div>
        </div>

        <div className="customer-info-form__actions">
          <button type="button" onClick={this.props.onBack} className="customer-info-form__btn customer-info-form__btn--back" disabled={this.props.submittingForm}>Back</button>
          <button type="submit" className="customer-info-form__btn customer-info-form__btn--continue" disabled={!this.isFormValid() || this.props.submittingForm} style={{ opacity: (this.isFormValid() && !this.props.submittingForm) ? 1 : 0.5, cursor: (this.isFormValid() && !this.props.submittingForm) ? 'pointer' : 'not-allowed' }}>{this.props.submittingForm ? 'Loading...' : 'Continue'}</button>
        </div>

        {showAccountCarMakeModal && currentMemberIndex !== null && (
          <CarOptionList type="car_make" title="Car Make" list={carMakeList} selection={currentAccountAlternateIndex !== null ? members[currentMemberIndex]?.alternate_vehicles?.[currentAccountAlternateIndex]?.vehicle_make : members[currentMemberIndex]?.vehicle_make} handleChange={this.handleCarMakeChange} close={this.closeModal} />
        )}
        {showAccountCarColorModal && currentMemberIndex !== null && (
          <CarOptionList type="car_color" title="Car Color" list={carColorList} selection={currentAccountAlternateIndex !== null ? members[currentMemberIndex]?.alternate_vehicles?.[currentAccountAlternateIndex]?.vehicle_color : members[currentMemberIndex]?.vehicle_color} handleChange={this.handleCarColorChange} close={this.closeModal} />
        )}
      </form>
    );
  }
}
